export default {
  primary: "https://inside.oddset.dk",
  secondary: "https://inside-links.oddset.dk",
};
